var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAidev3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1292ee;\n      }\n\n      .cls-2 {\n        isolation: isolate;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40,79.9C18,79.9.1,62,.1,40S18,.1,40,.1s39.9,17.9,39.9,39.9-17.9,39.9-39.9,39.9ZM40,1.1C18.6,1.1,1.1,18.6,1.1,40s17.4,38.9,38.9,38.9,38.9-17.4,38.9-38.9S61.4,1.1,40,1.1Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.5,56.3h-20.9c-3.2,0-5.9-2.6-5.9-5.9v-21c0-3.2,2.6-5.9,5.9-5.9h20.9c3.2,0,5.9,2.6,5.9,5.9v21c0,3.2-2.6,5.9-5.9,5.9ZM29.5,24.6c-2.7,0-4.9,2.2-4.9,4.9v21c0,2.7,2.2,4.9,4.9,4.9h20.9c2.7,0,4.9-2.2,4.9-4.9v-21c0-2.7-2.2-4.9-4.9-4.9h-20.9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.9,
    y: 39.5,
    width: 14.3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 17.3,
    y: 48.4,
    width: 6.9,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 17.3,
    y: 30.9,
    width: 6.9,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.5,
    y: 55.8,
    width: 1,
    height: 14.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48.4,
    y: 55.8,
    width: 1,
    height: 6.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 30.9,
    y: 55.8,
    width: 1,
    height: 6.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.7,
    y: 9.9,
    width: 1,
    height: 14.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 30.8,
    y: 17.3,
    width: 1,
    height: 6.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48.2,
    y: 17.3,
    width: 1,
    height: 6.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55.9,
    y: 48.4,
    width: 6.9,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55.9,
    y: 30.9,
    width: 6.9,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55.9,
    y: 39.5,
    width: 14.3,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.4,43c-1.6,0-3-1.3-3-3s1.3-3,3-3,3,1.3,3,3-1.3,3-3,3ZM7.4,38c-1.1,0-2,.9-2,2s.9,2,2,2,2-.9,2-2-.9-2-2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.7,51.9c-1.6,0-3-1.3-3-3s1.3-3,3-3,3,1.3,3,3-1.3,3-3,3ZM14.7,46.9c-1.1,0-2,.9-2,2s.9,2,2,2,2-.9,2-2-.9-2-2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.7,34.4c-1.6,0-3-1.3-3-3s1.3-3,3-3,3,1.3,3,3-1.3,3-3,3ZM14.7,29.4c-1.1,0-2,.9-2,2s.9,2,2,2,2-.9,2-2-.9-2-2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.4,68.2c-1.6,0-3-1.3-3-3s1.3-3,3-3,3,1.3,3,3-1.3,3-3,3ZM31.4,63.2c-1.1,0-2,.9-2,2s.9,2,2,2,2-.9,2-2-.9-2-2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40,75.6c-1.6,0-3-1.3-3-3s1.3-3,3-3,3,1.3,3,3-1.3,3-3,3ZM40,70.6c-1.1,0-2,.9-2,2s.9,2,2,2,2-.9,2-2-.9-2-2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.9,68.2c-1.6,0-3-1.3-3-3s1.3-3,3-3,3,1.3,3,3-1.3,3-3,3ZM48.9,63.2c-1.1,0-2,.9-2,2s.9,2,2,2,2-.9,2-2-.9-2-2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.2,51.9c-1.6,0-3-1.3-3-3s1.3-3,3-3,3,1.3,3,3-1.3,3-3,3ZM65.2,46.9c-1.1,0-2,.9-2,2s.9,2,2,2,2-.9,2-2-.9-2-2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.6,43c-1.6,0-3-1.3-3-3s1.3-3,3-3,3,1.3,3,3-1.3,3-3,3ZM72.6,38c-1.1,0-2,.9-2,2s.9,2,2,2,2-.9,2-2-.9-2-2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.2,34.4c-1.6,0-3-1.3-3-3s1.3-3,3-3,3,1.3,3,3-1.3,3-3,3ZM65.2,29.4c-1.1,0-2,.9-2,2s.9,2,2,2,2-.9,2-2-.9-2-2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.8,17.8c-1.6,0-3-1.3-3-3s1.3-3,3-3,3,1.3,3,3-1.3,3-3,3ZM48.8,12.8c-1.1,0-2,.9-2,2s.9,2,2,2,2-.9,2-2-.9-2-2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.2,10.4c-1.6,0-3-1.3-3-3s1.3-3,3-3,3,1.3,3,3-1.3,3-3,3ZM40.2,5.4c-1.1,0-2,.9-2,2s.9,2,2,2,2-.9,2-2-.9-2-2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.2,17.8c-1.6,0-3-1.3-3-3s1.3-3,3-3,3,1.3,3,3-1.3,3-3,3ZM31.2,12.8c-1.1,0-2,.9-2,2s.9,2,2,2,2-.9,2-2-.9-2-2-2Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.7,43.1l-1.6,5h-2.1l5.4-15.8h2.5l5.4,15.8h-2.2l-1.7-5h-5.6ZM39.9,41.5l-1.5-4.5c-.4-1-.6-2-.8-2.9h0c-.2.9-.5,1.9-.8,2.9l-1.5,4.6h4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.5,32.2v15.8h-2v-15.8h2Z"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAidev3);
export default __webpack_public_path__ + "static/media/aidev3.404f74f577b0218bf9f59b732421e350.svg";
export { ForwardRef as ReactComponent };